import { Button, Paragraph } from '@zillow/constellation-10';

type Props = {
  displayText?: string;
  disabled?: boolean;
};

export const BigDropzone = ({ displayText, disabled }: Props) => (
  <>
    <Paragraph css={{ marginBlock: 'default' }}>{displayText ? displayText : 'Drag photos here'}</Paragraph>
    <Button size="sm" data-testid="BigDropzone-SelectFromComputer" disabled={disabled}>
      Select from computer
    </Button>
  </>
);
